<template >
  <Modal v-model="isVisible" title="批量编辑质检模板" width="800">
    <div class="quality-edit">
      <Form
        class="quality-edit-form"
        ref="formQualityEdit"
        :model="formData"
        :label-width="80"
        label-position="right"
      >
        <Form-item label="质检模板：">
          <dyt-select v-model="formData.qualityTemplateId" :transfer="false" placeholder="请选择质检项目">
            <Option
              v-for="(option, index) in qualityTemplateList"
              :value='option.qualityClassificationId'
              :key="`b_${index}`"
            >{{option.qualityClassification}}</Option>
          </dyt-select>
        </Form-item>
        <div style="padding: 0 0 15px 20px;">
          <Button type="primary" @click="addQualityObject" :disabled="pageLoading">新增质检项目</Button>
          <Table class="mt10 quality-edit-table" highlight-row border :height="tableHeight" :columns="tableColumns" :data="formData.tableData">
            <template slot-scope="{ index, row }" slot="operate">
              <Button type="error" size="small" @click="removeTableRow(row, index)" :disabled="pageLoading">删除</Button>
            </template>
            <template slot-scope="{ index, row }" slot="qualityProject">
              <Form-item
                label=""
                :label-width="0"
                :prop="`tableData.${index}.qualityProject`"
                :rules="tableValidate.qualityProject"
              >
                <Input
                  v-model="formData.tableData[index].qualityProject"
                  placeholder="请输入质检项目"

                />
              </Form-item>
            </template>
            <template slot-scope="{ index, row }" slot="qualityDescription">
              <Form-item
                label=""
                :label-width="0"
                :prop="`tableData.${index}.qualityDescription`"
                :rules="tableValidate.qualityDescription"
              >
                <Input v-model="formData.tableData[index].qualityDescription" placeholder="请输入质检内容描述" />
              </Form-item>
            </template>
            <template slot-scope="{ index, row }" slot="qualityPrice">
              <Form-item
                label=""
                :label-width="0"
                :prop="`tableData.${index}.price`"
                :rules="tableValidate.price"
              >
                <Input v-model="formData.tableData[index].price" placeholder="请输入价格" />
              </Form-item>
            </template>
          </Table>
          <div style="padding: 15px 20px 0 0; text-align: right;">质检价格合计：{{ editModalTotal.toFixed(2) }}</div>
        </div>
      </Form>
      <Spin v-if="pageLoading" fix></Spin>
    </div>
    <div slot="footer">
      <Button @click="isVisible = false">取 消</Button>
      <Button type="primary" @click="saveQuality" :disabled="pageLoading">确 定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'batchQualityEdit',
  props: {
    modalVisible: { type: Boolean, default: false },
    refreshTable: { type: Boolean, default: false },
    classificationId: { type: [Number, String], default: null },
    spuTotal: { type: Number, default: null },
    qualityEditData: { type: Array, default: () => { return [] } },
    selectAll: { type: Boolean, default: false },
    searchParams: { type: Function, default: () => { return {} } },
  },
  data () {
    return {
      isVisible: false,
      oldData: [],
      // 表单数据组
      formData: {
        classificationId: '',
        qualityTemplateId: '',
        tableData: []
      },
      // 表单验证规则
      formRule: {},
      oldFormData: {},
      qualityTemplateList: [],
      tableHeight: 450,
      tableColumns: [
        {
          title: '操作',
          slot: 'operate',
          width: 90,
          align: 'center',
        },
        {
          title: '质检项目',
          slot: 'qualityProject',
          width: 150,
          align: 'left',
        },
        {
          title: '质检内容描述',
          slot: 'qualityDescription',
          minWidth: 200,
          align: 'left',
        },
        {
          title: '价格',
          slot: 'qualityPrice',
          width: 120,
        }
      ],
      qualityTemplateJson: {},
      pageLoading: false,
      tableValidate: {
        qualityProject: [
          { required: true, validator: this.$common.formItemVerify, msg: '请输入质检项目', trigger: 'change' },
          { required: true, validator: this.$common.formItemVerify, msg: '请输入质检项目', trigger: 'blur' },
        ],
        qualityDescription: [
          { required: true, validator: this.$common.formItemVerify, msg: '请输入质检内容描述', trigger: 'change' },
          { required: true, validator: this.$common.formItemVerify, msg: '请输入质检内容描述', trigger: 'blur' },
        ],
        price: [
          { required: true, validator: this.$common.validatorMaxNumber, msg: '请输入价格', min: 0, point: 2, trigger: 'change' },
          { required: true, validator: this.$common.validatorMaxNumber, msg: '请输入价格', min: 0, point: 2, trigger: 'blur' },
        ]
      }
    }
  },
  watch: {
    modalVisible: {
      immediate: true,
      handler (val) {
        this.isVisible = val;
        val ? this.initData() : this.restData();
      }
    },
    isVisible: {
      handler (val) {
        this.$emit('update:modalVisible', val);
      }
    },
    getResData: {
      immediate: true,
      deep: true,
      handler (val) {
        this.oldData = this.$common.copy(val || []);
        this.formData.tableData = this.$common.copy(val || []);
      }
    }
  },
  created () {},
  computed: {
    getResData () {
      return this.qualityTemplateJson[this.formData.qualityTemplateId] || [];
    },
    editModalTotal () {
      if (this.$common.isEmpty(this.formData.tableData)) return 0;
      let priceTotal = 0;
      let newPrice = null;
      this.formData.tableData.forEach(row => {
        newPrice = Number(row.price);
        if (!(this.$common.isEmpty(newPrice) || newPrice < 0)) {
          priceTotal += newPrice;
        }
      });
      return priceTotal;
    }
  },
  methods: {
    // 初始化页面数据
    initData () {
      this.pageLoading = true;
      this.oldFormData = this.$common.copy(this.formData);
      this.formData.classificationId = this.classificationId;
      const getDataArray = [() => {
        return this.getAllQuality()
      }];
      // 初始化需要获取的数据
      this.$common.allSettled(getDataArray).then((arr) => {
        this.pageLoading = false;
      }).catch(() => {
        this.pageLoading = false;
      })
    },
    // 新增质检项目
    addQualityObject () {
      // if (this.$common.isEmpty(this.formData.qualityTemplateId)) return;
      this.formData.tableData.push({
        qualityProject: '',
        qualityDescription: '',
        price: '',
      });
    },
    // 移除列表行
    removeTableRow (row, index) {
      if (this.$common.isEmpty(row.qualityProject)) {
        this.formData.tableData.splice(index, 1);
        return;
      }
      this.$Modal.confirm({
        title: '操作提示',
        content: `确认删除质检项目：<span style="color:#f20;">${row.qualityProject}</span>`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.formData.tableData.splice(index, 1);
        }
      })
    },
    // 保存
    saveQuality () {
      let oldTxt = '';
      let newTxt = '';
      (this.oldData || []).forEach(row => {
        oldTxt = `${oldTxt}${row.qualityProject || ''}${row.qualityDescription || ''}${row.price || ''}`;
      });
      (this.formData.tableData || []).forEach(row => {
        newTxt = `${newTxt}${row.qualityProject || ''}${row.qualityDescription || ''}${row.price || ''}`;
      });
      // 当里面的内容不一致时，使用另外的一个接口保存
      if (oldTxt !== newTxt || this.oldData.length != this.formData.tableData.length) {
        this.newSaveQuality();
        return;
      }
      if (this.$common.isEmpty(this.formData.qualityTemplateId)) {
        this.$Message.error('请选择质检模板');
        return;
      }
      let formParams = {
        selectAll: this.selectAll === true ? 1 : 0,
      };
      this.$Modal.confirm({
        title: '确认是否批量修改数据？',
        content: `这次修改数据：${this.selectAll === true ? this.spuTotal : this.qualityEditData.length} 条`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.pageLoading = true;
          if (this.selectAll) {
            formParams = {
              ...formParams,
              ...this.searchParams()
            }
          } else {
            formParams.productIdList = this.qualityEditData.map(p => p.productId);
          }
          if (this.$common.isEmpty(this.formData.qualityTemplateId)) {
            this.$Message.error('请选择质检模板');
            return;
          }
          this.axios.post(`${api.batchUpdateProductQualityTemplate}${this.formData.qualityTemplateId}`, formParams).then(res => {
            this.pageLoading = false;
            if (res.data && res.data.code == 0) {
              this.$Message.success('修改成功！');
              // 当关闭弹窗时去刷新列表
              this.$emit('update:refreshTable', true);
              this.$nextTick(() => {
                this.isVisible = false;
              })
            }
          }).catch(() => {
            this.pageLoading = false;
          })
          // this.$Modal.remove();
        }
      });
    },
    // 新保存逻辑
    newSaveQuality () {
      this.$refs.formQualityEdit.validate((valid) => {
        if (!valid) {
          let formName = '.quality-edit-form';
          setTimeout(() => {
            const dome = document.querySelector(`${formName} .ivu-form-item-error-tip`);
            if (dome) {
              const tips = dome.textContent;
              if (!this.$common.isEmpty(tips)) {
                this.$Message.error(tips);
              }
            }
          }, 300);
          return this.$common.inputFocus(formName);
        }
        let formParams = {
          selectAll: this.selectAll === true ? 1 : 0,
          productCustomQualityProjectList: this.formData.tableData.map((item) => {
            return {
              qualityProject: item.qualityProject,
              qualityDescription: item.qualityDescription,
              price: item.price,
            }
          }),
        };
        this.$Modal.confirm({
          title: '确认是否批量修改数据？',
          content: `这次修改数据：${this.selectAll === true ? this.spuTotal : this.qualityEditData.length} 条`,
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            this.pageLoading = true;
            if (this.selectAll) {
              formParams = {
                ...formParams,
                ...this.searchParams()
              }
            } else {
              formParams.productIdList = this.qualityEditData.map(p => p.productId);
            }
            this.axios.post(api.batchUpdateQualityTemplate, formParams).then(res => {
              this.pageLoading = false;
              if (res.data && res.data.code == 0) {
                this.$Message.success('修改成功！');
                // 当关闭弹窗时去刷新列表
                this.$emit('update:refreshTable', true);
                this.$nextTick(() => {
                  this.isVisible = false;
                })
              }
            }).catch(() => {
              this.pageLoading = false;
            })
          }
        });
      })
    },
    // 重置页面数据
    restData () {
      !this.$common.isEmpty(this.oldFormData) && (this.formData = this.$common.copy(this.oldFormData));
      this.qualityTemplateList = [];
    },
    // 获取所有质检模板
    getAllQuality () {
      return new Promise((resolve) => {
        this.qualityTemplateJson = {};
        this.axios.get(api.getAllQualityTemplate).then((res) => {
          if (res && res.data && res.data.code === 0) {
            resolve(res.data.datas || []);
            this.qualityTemplateList = res.data.datas || [];
            (res.data.datas || []).forEach(item => {
              this.$set(this.qualityTemplateJson, item.qualityClassificationId, item.qualityProjectVOList);
            })
          } else {
            resolve([]);
          }
        }).catch(() => {
          resolve([]);
        })
      })
    }
  }
};
</script>
<style lang="less" scoped>
.quality-edit{
  .quality-edit-table{
    :deep(.ivu-table-tbody) {
      .ivu-form-item{
        margin-bottom: 0;
      }
    }
  }
}
</style>
